import { SIGN_IN_PATH } from 'constant/authenticationPath';
import useCheckRouterValid from 'hook/useCheckRouterValid';
import { ButtonStyled, Container, NotfoundWrapper } from 'page/NotFound/styled';
import { Navigate, useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { authenticationToken } from 'recoil/atom/authentication';
import useSetTitlePage from "../../hook/useSetTitlePage";


const NotFound = () => {
  const navigate = useNavigate();
  const { accessToken } = useRecoilValue(authenticationToken);
  useSetTitlePage('NOT FOUND', true);
  const { checkRouterValid } = useCheckRouterValid();

  if (!checkRouterValid && accessToken?.length === 0) {
    return <Navigate to={SIGN_IN_PATH} replace />;
  }

  const handleNavigateToHomePage = () => {
    navigate('/');
  };

  return (
    <NotfoundWrapper>
      <Container>
      <ButtonStyled size='large'  onClick={handleNavigateToHomePage}>Back to Home Page</ButtonStyled>
      </Container>
    </NotfoundWrapper>
  );
};

export default NotFound;
